import {Component} from '@angular/core';

@Component({
  selector: 'gt-forbidden',
  template: `
    <div class="no-access">
      <h1>{{ 'forbidden.no_access' | translate }}</h1>
      <a href="/" (click)="onBackClick($event)">{{ 'global.back' | translate }}</a>
    </div>
  `,
  styles: [
    `
      .no-access {
        height: 60%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    `
  ]
})
export class ForbiddenComponent {
  onBackClick(event: Event) {
    if (window.history.length > 0) {
      event.preventDefault();
      window.history.back();
    }
  }
}
